module.exports = __webpack_public_path__ + "fonts/DINNextLTPro-LightItalic.6b3878fb.woff2";